import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import './LoadMore.scss';
import messages from './reportsMessages';

const LoadMore = props => (
  <React.Fragment>
    <hr className="my-3"/>
    <div className="text-center mb-3">
      <button className="load-more" onClick={props.onClick}>
        <FormattedMessage {...messages.seeMore} />
      </button>
    </div>
  </React.Fragment>  
);

LoadMore.propTypes = {};

export default LoadMore;
